// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"60":"1726419b","143":"007af0e4","453":"5e1088ce"}[chunkId] + ".chunk.js";
};